import Vue from 'vue'
//Plugins
import MaskedInput from 'vue-text-mask';
import VueScrollbar from './views/scroll/vue-scrollbar';
import 'vue2-scrollbar/dist/style/vue2-scrollbar.css';
import vSelect from 'vue-select';

import splitPane from "vue-splitpane";

//Gofix Component
const Pagination = () => import('./views/partial/Pagination');
const ColumnSetting = () => import('./views/partial/ColumnSetting');
const gofixFormSupplier = () => import("@/views/elements/forms/DropdownSupplier");
const gofixFormProperties = () => import("@/views/elements/forms/DropdownProperties");
const gofixFormDropdown = () => import("@/views/elements/forms/Dropdown");
const gofixFormDropdownTree = () => import("@/views/elements/forms/DropdownTree");
const gofixFormInput = () => import("@/views/elements/forms/InputText");
const gofixFormInputDate = () => import("@/views/elements/forms/InputDate");
const gofixFormInputNumber = () => import("@/views/elements/forms/InputNumber");
const gofixFormInputTextArea = () => import("@/views/elements/forms/InputTextArea");
const gofixFormInputTextEditor = () => import("@/views/elements/forms/InputTextEditor");
const gofixFormInputTime = () => import("@/views/elements/forms/InputTime");
const gofixButton = () => import("@/views/elements/buttons/buttons");
const gofixTab = () => import("@/views/elements/tabs/tab");
const gofixCard = () => import("@/views/elements/cards/card");
const gofixTextField = () => import("@/views/elements/texts/textfield");
const gofixAttachmentArea = () => import("@/views/elements/attachments/attachment-area");
const gofixSplit = () => import("@/views/elements/split/split");
const modalImport = () => import("@/views/partial/ModalImport");
import gofixAttachment from '@/views/attachments/list_v2';
import goFixTables from './views/tables/goFixTables';
import gofixDefaultTables from './views/tables/gofixDefaultTables';

//Plugins
Vue.component('masked-input', MaskedInput);
Vue.component('vue-scrollbar', VueScrollbar);
// Vue.component('v-select', vSelect);
// turn off scroll v-select
Vue.component('v-select', {
    extends: vSelect,
    methods: {
      maybeAdjustScroll: () => false
    }
});
Vue.component('split-pane', splitPane);

//Global GOfix Component
Vue.component('Pagination', Pagination);
Vue.component('ColumnSetting', ColumnSetting);
Vue.component('gofix-table', goFixTables);
Vue.component('gofix-default-table', gofixDefaultTables);
Vue.component("gofix-form-supplier", gofixFormSupplier);
Vue.component("gofix-form-properties", gofixFormProperties);
Vue.component("gofix-form-dropdown", gofixFormDropdown);
Vue.component("gofix-form-tree", gofixFormDropdownTree);
Vue.component("gofix-form-input", gofixFormInput);
Vue.component("gofix-form-input-number", gofixFormInputNumber);
Vue.component("gofix-form-input-date", gofixFormInputDate);
Vue.component("gofix-form-input-textarea", gofixFormInputTextArea);
Vue.component("gofix-form-input-texteditor", gofixFormInputTextEditor);
Vue.component("gofix-form-input-time", gofixFormInputTime);
Vue.component("gofix-button", gofixButton);
Vue.component("gofix-tab", gofixTab);
Vue.component("gofix-card", gofixCard);
Vue.component("gofix-text-field", gofixTextField);
Vue.component("gofix-attachment-area", gofixAttachmentArea);
Vue.component("gofix-split", gofixSplit);
Vue.component("modal-import", modalImport);
Vue.component("gofix-attachment", gofixAttachment);